import { GlobalLink } from 'components/Global/GlobalLink'

export const SectionHeader = ({ title, eyebrow, link }) => {
  return (
    <div className="w-full px-20 pt-20 md:pt-100">
      <div className="pb-14 text-10 uppercase leading-110 text-gray">
        {eyebrow}
      </div>
      <div className="flex text-20 font-bold leading-100">
        <h2 className="pr-16 text-darkGray">{title}</h2>
        {link?.to || link?.url ? (
          <GlobalLink link={link} className="text-gray">
            {link.label}
          </GlobalLink>
        ) : null}
      </div>
    </div>
  )
}
